<template>
  <MainMenuView class="main-menu">
    <MainMenu
      :is-user-data-ready="isUserDataReady"
      :routes="routes"
    />
  </MainMenuView>
</template>

<script>
import { mapGetters } from 'vuex';
import { MainMenuItems } from '../config';
import MainMenu from './main-menu';
import MainMenuView from './main-menu-view';
import { checkMenuItemsAvailability } from '@/shared/ui/menu-list';

export default {
  mixins: [ checkMenuItemsAvailability ],
  components: { MainMenuView, MainMenu },
  computed: {
    ...mapGetters('currentUserModule', ['isUserDataReady', 'getCurrentUser', 'getUserInfo']),
    ...mapGetters('layoutModule', ['windowWidth', 'windowHeight', 'isDesktop']),
    routes() {
      if (this.isUserDataReady) {
        return this.getAvailableMenuItems(MainMenuItems, {
          userInfo: this.getUserInfo,
          windowSize: {
            width: this.windowWidth,
            height: this.windowHeight,
            isDesktop: this.isDesktop,
          },
        });
      }

      return [];
    },
  },
};
</script>

<style lang="scss" scoped>
.main-menu {
  font-family: 'Geist', sans-serif;
  font-size: 14px;
  color: #09090B;
}
</style>
